import { useTranslation } from "react-i18next";
import ComponentCard from "../../../../shared/ui/common/ComponentCard";
import PageMeta from "../../../../shared/ui/common/PageMeta";

function TermsEs() {
    return (
        <div className="prose dark:prose-invert max-w-none space-y-4 text-content-secondary">
            <h1>AVISO LEGAL</h1>

            <h3>Información general</h3>
            <p>
                En cumplimiento de lo previsto en el artículo 10 de la Ley 34/2.002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa que la dirección URL (en adelante el sitio Web) es un dominio registrado por <strong>ARITZ AGUILA DIAZ</strong> en adelante, <strong>EL TITULAR</strong>), cuyos datos son los siguientes:
            </p>
            <ul className="list-none pl-0">
                <li><strong>CIF n.º</strong> B26960310</li>
                <li><strong>Domicilio:</strong> Basigoko Bide Nagusia, 20, 4 I, Bakio, 48130</li>
                <li><strong>Email de contacto:</strong> hello@alchely.com</li>
                <li><strong>Teléfono:</strong> 689 281 467</li>
            </ul>
            <p>EL TITULAR actúa como responsable de los contenidos del SITIO WEB.</p>

            <h3>Condiciones de uso</h3>
            <p>
                El acceso y uso de este sitio web atribuye la condición de USUARIO, quien, al navegar por este sitio, acepta íntegra, expresa y sin reservas, todas las cláusulas del presente aviso legal. Por ello, rogamos al USUARIO que lea detenidamente el presente aviso legal.
            </p>
            <p>
                EL TITULAR se reserva la facultad de modificar unilateralmente los términos y condiciones de este sitio, en cuyo caso procederá a la publicación de nuevos términos y condiciones en la página web.
            </p>
            <p>
                El acceso y uso de este sitio web por parte del USUARIO es gratuito y libre, no obstante, determinadas partes del sitio web cuentan con acceso reservado, <a href="https://app.alchely.com" className="text-accent-text">https://app.alchely.com</a> mediante un identificador de usuario y contraseña.
            </p>
            <p>
                En todo caso, el USUARIO asume la responsabilidad en el uso de la presente página web, y se compromete a navegar de buena fe y de forma diligente.
            </p>
            <p>
                En cualquier momento EL TITULAR puede modificar unilateralmente, y sin previo aviso, la presentación y/o configuración del sitio web, así como los servicios y contenidos prestados.
            </p>

            <h3>Responsabilidad del USUARIO</h3>
            <p>
                El USUARIO se compromete a no utilizar el SITIO WEB ni la información ofrecida en el mismo para la realización de actividades contrarias a la Ley, la moral o el orden público y, en general, a hacer un uso conforme a las condiciones establecidas por EL TITULAR.
            </p>
            <p>
                Las opiniones, contenidos y, en general, todas las actividades realizadas por el USUARIO son de su exclusiva responsabilidad, sin que pueda responsabilizarse a EL TITULAR, de los daños o perjuicios que pudieran derivarse de dichas actividades ajenas a su voluntad, y sin que éste tenga un conocimiento efectivo de las mismas.
            </p>

            <h3>Responsabilidad de EL TITULAR</h3>
            <p>
                EL TITULAR no será responsable de los errores en el acceso al SITIO WEB o en sus contenidos, aunque podrá la mayor diligencia en que los mismos no se produzcan.
            </p>
            <p>
                EL TITULAR se reserva el derecho de suspender temporalmente, y sin necesidad de previo aviso, la accesibilidad del SITIO WEB con motivo de una eventual necesidad de efectuar operaciones de mantenimiento, reparación, actualización, o mejora del mismo.
            </p>

            <h3>Propiedad Intelectual e Industrial</h3>
            <p>
                Todos los contenidos del SITIO WEB (incluyendo, sin carácter limitativo, bases de datos, imágenes, dibujos, gráficos, archivos de texto, audio, video y software) son propiedad de EL TITULAR, y están protegidos por las normas nacionales e internacionales de propiedad intelectual e industrial, quedando todos los derechos reservados.
            </p>
            <p>
                El nombre de dominio, las marcas, rótulos, signos distintivos o logos que aparecen en el SITIO WEB son titularidad de EL TITULAR.
            </p>
            <p>
                Todos los textos, dibujos gráficos, vídeos o soportes de audio que pudieran encontrarse en este momento, o en el futuro, en este sitio de Internet, son propiedad de EL TITULAR, y no podrán ser objeto de ulterior modificación, copia, alteración, reproducción total o parcial, adaptación o traducción por parte del USUARIO o de terceros, sin la expresa autorización por parte de EL TITULAR.
            </p>
            <p>
                El uso no autorizado de la información contenida en este SITIO WEB, así como la lesión de los derechos de propiedad intelectual o industrial dará lugar a las responsabilidades legalmente establecidas.
            </p>

            <h3>Hiperenlaces</h3>
            <p>El establecimiento de cualquier hiperenlace desde una página web ajena, a cualquiera de las páginas de EL TITULAR, estará sometido a las siguientes condiciones:</p>
            <ul className="list-disc pl-5">
                <li>No se permite la reproducción ni total ni parcial de ninguno de los servicios contenidos en el SITIO WEB de EL TITULAR.</li>
                <li>No se incluirá ninguna manifestación falsa, inexacta o incorrecta sobre las páginas del SITIO WEB de EL TITULAR, y sus servicios.</li>
                <li>Bajo ninguna circunstancia EL TITULAR será responsable de los contenidos, informaciones, manifestaciones, opiniones o servicios puestos a disposición del público en la página web desde la que se establezca un hiperenlace al presente SITIO WEB.</li>
                <li>Cualquier hiperenlace se efectuará a la página principal del SITIO WEB.</li>
                <li>Los hiperenlaces que se encuentran en el SITIO WEB han sido previamente consensuados con los titulares de las páginas web enlazadas. EL TITULAR no será responsable del mal uso ni de las actividades contrarias a la ley, la moral o el orden público que realicen los usuarios en dichas páginas enlazadas.</li>
            </ul>

            <h3>Vigencia de las condiciones de uso</h3>
            <p>
                Las condiciones de uso de este SITIO WEB tienen carácter indefinido. EL TITULAR se reserva en todo caso el derecho unilateral de modificar las condiciones de acceso a las mismas, así como su contenido.
            </p>

            <h3>Nulidad e ineficacia de las cláusulas</h3>
            <p>
                Si cualquier cláusula incluida en estas condiciones fuese declarada total o parcialmente nula o ineficaz, tal nulidad afectará tan solo a dicha disposición, o a la parte de la misma que resultare nula o ineficaz, subsistiendo en todo lo demás las condiciones.
            </p>

            <h3>Legislación y jurisdicción aplicables</h3>
            <p>
                La prestación de servicio de este SITIO WEB y las presentes condiciones de uso se rigen por la legislación española.
            </p>
            <p>
                EL TITULAR y el USUARIO, con renuncia expresa a cualquier otro fuero, se someten para cualquier controversia que pudiera derivarse del acceso o uso del presente sitio web, al de los Juzgados y Tribunales de Bilbao, Vizcaya, España.
            </p>
            <p>
                Toda cuestión litigiosa que incumba a los servicios prestados a través de este SITIO WEB será resuelta a través de los tribunales arbitrales de consumo, mediadores o semejantes a los que se encuentre adherido EL TITULAR en el momento de producirse la controversia, así como los juzgados y tribunales correspondientes de conformidad con la legislación española.
            </p>
        </div>
    );
}

function TermsEn() {
    return (
        <div className="prose dark:prose-invert max-w-none space-y-4 text-content-secondary">
            <h1>LEGAL NOTICE</h1>

            <h3>General Information</h3>
            <p>
                In compliance with the provisions of Article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce, it is reported that the URL address (hereinafter the Website) is a domain registered by <strong>ARITZ AGUILA DIAZ</strong> (hereinafter, <strong>THE OWNER</strong>), whose details are as follows:
            </p>
            <ul className="list-none pl-0">
                <li><strong>CIF No.:</strong> B26960310</li>
                <li><strong>Address:</strong> Basigoko Bide Nagusia, 20, 4 I, Bakio, 48130</li>
                <li><strong>Contact Email:</strong> hello@alchely.com</li>
                <li><strong>Telephone:</strong> 689 281 467</li>
            </ul>
            <p>THE OWNER acts as the person responsible for the contents of the WEBSITE.</p>

            <h3>Terms of Use</h3>
            <p>
                Access to and use of this website attributes the status of USER, who, by browsing this site, accepts fully, expressly, and without reservation all the clauses of this legal notice. Therefore, we ask the USER to read this legal notice carefully.
            </p>
            <p>
                THE OWNER reserves the right to unilaterally modify the terms and conditions of this site, in which case new terms and conditions will be published on the website.
            </p>
            <p>
                Access and use of this website by the USER is free and open; however, certain parts of the website have restricted access via a user ID and password at <a href="https://app.alchely.com" className="text-accent-text">https://app.alchely.com</a>.
            </p>
            <p>
                In any case, the USER assumes responsibility for the use of this website and agrees to browse in good faith and in a diligent manner.
            </p>
            <p>
                At any time, THE OWNER may unilaterally modify, without prior notice, the presentation and/or configuration of the website, as well as the services and contents provided.
            </p>

            <h3>Responsibility of the USER</h3>
            <p>
                The USER agrees not to use the WEBSITE or the information offered therein to carry out activities contrary to the Law, morality, or public order and, in general, to make use in accordance with the conditions established by THE OWNER.
            </p>
            <p>
                The opinions, contents, and, in general, all activities carried out by the USER are their exclusive responsibility; THE OWNER cannot be held responsible for damages or losses that may derive from said activities beyond their control and without having effective knowledge of them.
            </p>

            <h3>Responsibility of THE OWNER</h3>
            <p>
                THE OWNER shall not be responsible for errors in accessing the WEBSITE or its contents, although they will apply the greatest diligence to ensure they do not occur.
            </p>
            <p>
                THE OWNER reserves the right to temporarily suspend, without prior notice, the accessibility of the WEBSITE due to a possible need to carry out maintenance, repair, update, or improvement operations.
            </p>

            <h3>Intellectual and Industrial Property</h3>
            <p>
                All contents of the WEBSITE (including, without limitation, databases, images, drawings, graphics, text files, audio, video, and software) are the property of THE OWNER and are protected by national and international intellectual and industrial property regulations, with all rights reserved.
            </p>
            <p>
                The domain name, trademarks, signs, distinctive marks, or logos appearing on the WEBSITE are owned by THE OWNER.
            </p>
            <p>
                All texts, graphic drawings, videos, or audio supports that may be found now or in the future on this Internet site are the property of THE OWNER and may not be subject to subsequent modification, copying, alteration, total or partial reproduction, adaptation, or translation by the USER or third parties without express authorization from THE OWNER.
            </p>
            <p>
                Unauthorized use of the information contained in this WEBSITE, as well as the infringement of intellectual or industrial property rights, will give rise to legally established responsibilities.
            </p>

            <h3>Hyperlinks</h3>
            <p>The establishment of any hyperlink from an external website to any of the pages of THE OWNER shall be subject to the following conditions:</p>
            <ul className="list-disc pl-5">
                <li>Total or partial reproduction of any of the services contained in the WEBSITE of THE OWNER is not permitted.</li>
                <li>No false, inaccurate, or incorrect statement about the pages of THE OWNER'S WEBSITE and its services shall be included.</li>
                <li>Under no circumstances shall THE OWNER be responsible for the contents, information, statements, opinions, or services made available to the public on the website from which a hyperlink to this WEBSITE is established.</li>
                <li>Any hyperlink shall be made to the main page of the WEBSITE.</li>
                <li>The hyperlinks found on the WEBSITE have been previously agreed upon with the owners of the linked websites. THE OWNER shall not be responsible for the misuse or activities contrary to the law, morality, or public order carried out by users on said linked pages.</li>
            </ul>

            <h3>Validity of the Terms of Use</h3>
            <p>
                The terms of use of this WEBSITE are of an indefinite nature. THE OWNER reserves the right in any case to unilaterally modify the conditions of access to them, as well as their content.
            </p>

            <h3>Nullity and Ineffectiveness of Clauses</h3>
            <p>
                If any clause included in these conditions is declared totally or partially null or ineffective, such nullity will only affect said provision, or the part thereof that is null or ineffective, with the remaining conditions subsisting.
            </p>

            <h3>Applicable Legislation and Jurisdiction</h3>
            <p>
                The provision of service of this WEBSITE and these terms of use are governed by Spanish legislation.
            </p>
            <p>
                THE OWNER and the USER, expressly waiving any other jurisdiction, submit to the Courts and Tribunals of Bilbao, Vizcaya, Spain, for any controversy that may arise from the access or use of this website.
            </p>
            <p>
                Any litigious issue concerning the services provided through this WEBSITE will be resolved through consumer arbitration tribunals, mediators, or similar entities to which THE OWNER is affiliated at the time the controversy arises, as well as the corresponding courts and tribunals in accordance with Spanish legislation.
            </p>
        </div>
    );
}

export default function TermsOfService() {
    const { t, i18n } = useTranslation();
    const isSpanish = i18n.language?.startsWith("es");

    return (
        <>
            <PageMeta title={t("legal.termsTitle")} />
            <div className="max-w-4xl mx-auto py-10 px-4">
                <ComponentCard title={t("legal.termsTitle")}>
                    {isSpanish ? <TermsEs /> : <TermsEn />}
                </ComponentCard>
            </div>
        </>
    );
}
